//
// Site Header
// --------------------------------------------------
// Functionality for desktop/mobile navigation menu toggling

import { lockBody, unlockBody } from "../../../shared/js/helpers/body-lock-toggle";

window.addEventListener('load', () => {
    const siteHeader = document.getElementById('siteHeader');
    const siteFooter = document.getElementById('siteFooter');

    if (siteHeader) {
        const mainMobileNavContainer = siteHeader.querySelector('[data-nav-mobile-active-drawer]');
        const mainMobileNavToggles = document.querySelectorAll('[data-nav-toggle]');
        const mobileNavDropdowns = siteHeader.querySelectorAll('[data-tw-toggle-container]');

        const desktopDrawerContainer = siteHeader.querySelector('[data-nav-desktop-active-drawer]');
        const desktopDrawerToggles = siteHeader.querySelectorAll('[data-desktop-drawer-toggle]');

        // make nav visible / accessible 500ms after page load
        setTimeout( function() {
            mainMobileNavContainer.removeAttribute('style');
            desktopDrawerContainer.removeAttribute('style');
        }, 500);

        // id for below is retrieved from animated-hamburger.svg
        const hamburger = document.getElementById('ek0RzW3Va4r1');
        const hamburgerContainer = hamburger.closest('button');
        // https://www.svgator.com/help/getting-started/svgator-player-js-api
        // ^ related to below svgatorPlayer controls
        const hamburgerPlayer = hamburger ? hamburger.svgatorPlayer : {};

        siteHeader.addEventListener('click', () => {
            const clickedElement = event.target;

            // Check if the clicked element is a navigation toggle
            if (clickedElement.hasAttribute('data-nav-toggle')) {

                if (mainMobileNavContainer.dataset.active === 'false') {
                    mainMobileNavContainer.dataset.navMobileActiveDrawer = '1';
                    mainMobileNavContainer.dataset.active = 'true';
                    hamburgerContainer.dataset.active = 'true';
                    if (clickedElement.dataset.navToggle.length) {
                        mainMobileNavContainer.dataset.navMobileActiveDrawer = clickedElement.dataset.navToggle;
                    }
                    for (const mainMobileNavToggle of mainMobileNavToggles) {
                        mainMobileNavToggle.dataset.active = 'true';
                    }
                    lockBody();
                } else {
                    mainMobileNavContainer.dataset.active = 'false';
                    hamburgerContainer.dataset.active = 'false';
                    for (const mainMobileNavToggle of mainMobileNavToggles) {
                        mainMobileNavToggle.dataset.active = 'false';
                    }
                    resetMobileNavDropdowns();
                    unlockBody();
                }

                if (hamburger) {
                    if (hamburgerPlayer.play) {
                        if (hamburgerPlayer.hasEnded || hamburgerPlayer.isPlaying) {
                            hamburgerPlayer.reverse();
                        } else {
                            hamburgerPlayer.play();
                        }
                    }
                }

                startListening();
            }

            if (clickedElement.hasAttribute('data-open-nav-and-drawer')) {
                const menuToggleIndex = clickedElement.dataset.openNavAndDrawer;

                if (mainMobileNavContainer.dataset.active === 'false') {
                    mainMobileNavContainer.dataset.active = 'true';
                    clickedElement.dataset.active = 'true';
                    hamburgerContainer.dataset.active = 'true';
                    mainMobileNavContainer.dataset.navMobileActiveDrawer = menuToggleIndex;
                    lockBody();
                }

                if (hamburger) {
                    if (hamburgerPlayer.play) {
                        if (hamburgerPlayer.hasEnded || hamburgerPlayer.isPlaying) {
                            hamburgerPlayer.reverse();
                        } else {
                            hamburgerPlayer.play();
                        }
                    }
                }

                startListening();
            }

            if (clickedElement.hasAttribute('data-nav-drawer-toggle')) {
                // gets the identifier from the toggle and assigns it to main container
                // ( or resets to 1 if active drawer toggle was clicked)
                const menuToggleIndex = clickedElement.dataset.navDrawerToggle;
                if (mainMobileNavContainer.dataset.navMobileActiveDrawer === menuToggleIndex) {
                    mainMobileNavContainer.dataset.navMobileActiveDrawer = '1';
                } else {
                    mainMobileNavContainer.dataset.navMobileActiveDrawer = menuToggleIndex;
                }
                resetMobileNavDropdowns();
            }

            if (clickedElement.hasAttribute('data-desktop-drawer-toggle')) {
                const menuToggleIndex = clickedElement.dataset.desktopDrawerToggle;
                if (desktopDrawerContainer.dataset.navDesktopActiveDrawer === menuToggleIndex) {
                    desktopDrawerContainer.dataset.navDesktopActiveDrawer = '1';
                    closeAllNavs();
                } else {
                    desktopDrawerContainer.dataset.active = 'true';
                    desktopDrawerContainer.dataset.navDesktopActiveDrawer = menuToggleIndex;
                }
                startListening();
            }
        });

        // addition to open members section of the navigation via a link in the footer.
        if (siteFooter) {
            const openNavMembers = siteFooter.querySelector('[data-open-nav-members]');

            if (openNavMembers) {
                openNavMembers.addEventListener('click', () => {
                    const menuToggleIndex = openNavMembers.dataset.openNavMembers;
                    const mobileMenuMediaQuery = window.matchMedia('(max-width: 1023px)');

                    if (mobileMenuMediaQuery.matches) {
                        if (mainMobileNavContainer.dataset.active === 'false') {
                            // adding delay here so initial code doesn't instantly close nav
                            // as click to open was outside of site header
                            setTimeout(() => {
                                mainMobileNavContainer.dataset.active = 'true';
                                hamburgerContainer.dataset.active = 'true';
                                mainMobileNavContainer.dataset.navMobileActiveDrawer = menuToggleIndex;
                                lockBody();

                                if (hamburger) {
                                    if (hamburgerPlayer.play) {
                                        if (hamburgerPlayer.hasEnded || hamburgerPlayer.isPlaying) {
                                            hamburgerPlayer.reverse();
                                        } else {
                                            hamburgerPlayer.play();
                                        }
                                    }
                                }

                                startListening();
                            }, 50);
                        }
                    } else {
                        if (desktopDrawerContainer.dataset.navDesktopActiveDrawer === menuToggleIndex) {
                            desktopDrawerContainer.dataset.navDesktopActiveDrawer = '1';
                            closeAllNavs();
                        } else {
                            // adding delay here so initial code doesn't instantly close nav
                            // as click to open was outside of site header
                            setTimeout(() => {
                                desktopDrawerContainer.dataset.active = 'true';
                                desktopDrawerContainer.dataset.navDesktopActiveDrawer = menuToggleIndex;
                                startListening();
                            }, 50);
                        }
                    }
                });
            }
        }

        function resetMobileNavDropdowns() {
            for (const mobileNavDropdown of mobileNavDropdowns) {
                mobileNavDropdown.dataset.open = 'false';
            }
        }

        // removes all event listeners added when menu was opened
        function closeAllNavs() {
            for (const mainMobileNavToggle of mainMobileNavToggles) {
                mainMobileNavToggle.dataset.active = 'false';
            }
            if (mainMobileNavContainer.dataset.active === 'true') {
                if (hamburger) {
                    hamburgerContainer.dataset.active = 'false';
                    if (hamburgerPlayer.play) {
                        hamburgerPlayer.reverse();
                    }
                }
            }
            desktopDrawerContainer.dataset.navDesktopActiveDrawer = '1';
            mainMobileNavContainer.dataset.active = 'false';
            desktopDrawerContainer.dataset.active = 'false';
            resetMobileNavDropdowns();
            unlockBody();
            stopListening();
        }

        // function that closes navs on window width resize
        function resizeCloseNav() {
            const windowSize = window.innerWidth;
            const checkWidth = setTimeout(() => {
                if (windowSize !== window.innerWidth) {
                    closeAllNavs();
                }
            }, 50);
        }

        // function that closes navs on click outside menu
        function clickOutsideCloseNav() {
            if (!(document.getElementById('siteHeader').contains(event.target))) {
                closeAllNavs();
            }
        }

        // Helper function to create debounced and throttled functions
        function createDebouncedAndThrottledFunction(fn, delay) {
            const debounced = _debounce(fn, delay, { leading: true, trailing: true });
            const throttled = _throttle(debounced, delay, { leading: true, trailing: true });
            return throttled;
        }

        // Function to handle the "Escape" key press
        function escapeKeyListener(e) {
            if (e.key === "Escape") {
                closeAllNavs();
            }
        }

        const closeNavResizeThrottle = createDebouncedAndThrottledFunction(resizeCloseNav, 50);
        const closeNavClickDebounce = createDebouncedAndThrottledFunction(clickOutsideCloseNav, 50);

        // adds listeners on open of navigation
        function startListening() {
            window.addEventListener('click', clickListener);
            window.addEventListener('resize', resizeListener);
            document.addEventListener('keydown', escapeKeyListener);
        }

        // removes listeners on closing of menus
        function stopListening() {
            window.removeEventListener('click', clickListener);
            window.removeEventListener('resize', resizeListener);
            document.removeEventListener('keydown', escapeKeyListener);
        }

        const clickListener = () => {
            closeNavClickDebounce(event);
        };

        const resizeListener = () => {
            closeNavResizeThrottle();
        };
    }
});
